import { createContext, useContext } from "react";

import type { PartnerSession } from "@/modules/PartnerPortal/types";

/** The signed-in partner, set by `PartnerGuard` once `/me` answers. */
export const PartnerSessionContext = createContext<PartnerSession | null>(null);

export function usePartnerSessionContext(): PartnerSession {
  const session = useContext(PartnerSessionContext);
  if (!session) throw new Error("usePartnerSessionContext must be used inside PartnerGuard");
  return session;
}
